export const CREATOR_REGISTER_SESSION_KEY = "creator-register:session";
export const CREATOR_REGISTER_OAUTH_NONCE_KEY = "creator-register:oauth-nonce";
export const CREATOR_REGISTER_OAUTH_ERROR_KEY = "creator-register:oauth-error";
export const CREATOR_REGISTER_OAUTH_STATE_PREFIX = "creator-register:";

export interface RoleRegisterSession {
	registrationRole?: "creator" | "client" | "agency";
	email: string;
	firstName: string;
	lastName: string;
	// Clients only (password sign-up): how they appear in comments.
	displayName: string;
	accepted: boolean;
	emailVerified?: boolean;
	google?: {
		signupToken: string;
		email: string;
		expiresAt: number;
	};
	// An invitation sign-up that went to Google, so GoogleCallback can
	// return to the invitation's sign-up page.
	invite?: {
		token: string;
		email: string;
	};
}

export const emptyRoleRegisterSession = (): RoleRegisterSession => ({
	email: "",
	firstName: "",
	lastName: "",
	displayName: "",
	accepted: false,
});

export const readRoleRegisterSession = (): RoleRegisterSession => {
	try {
		const raw = sessionStorage.getItem(CREATOR_REGISTER_SESSION_KEY);
		if (!raw) return emptyRoleRegisterSession();
		return { ...emptyRoleRegisterSession(), ...(JSON.parse(raw) as RoleRegisterSession) };
	} catch {
		return emptyRoleRegisterSession();
	}
};

export const writeRoleRegisterSession = (value: RoleRegisterSession): void => {
	sessionStorage.setItem(CREATOR_REGISTER_SESSION_KEY, JSON.stringify(value));
};

export const clearRoleRegisterSession = (): void => {
	sessionStorage.removeItem(CREATOR_REGISTER_SESSION_KEY);
	sessionStorage.removeItem(CREATOR_REGISTER_OAUTH_NONCE_KEY);
	sessionStorage.removeItem(CREATOR_REGISTER_OAUTH_ERROR_KEY);
};
